export enum HttpResponseType {
  JSON = 'json',
  TEXT = 'text',
}
